import React, { useEffect, useMemo, useState } from "react";
import SocialLinks from "./SocialLinks";
import "../styles/components.css";

export default function HeroBanner() {
    const slides = useMemo(
        () => [
            {
                src: "/assets/Graphics/Hero_Image.png",
                eyebrow: "",
                title: "Beach Bum Pass",
                subtitle: "One pass. Endless coastal experiences.",
                description:
                    "Unlock the best activities, attractions, and local favorites across Fort Walton Beach, Okaloosa Island, and the Emerald Coast.",
            },
        ],
        []
    );

    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        if (slides.length <= 1) return undefined;

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [slides.length]);

    const activeSlide = slides[currentSlide];

    return (
        <section className="hero-banner bbp-hero-v2" aria-label="Beach Bum Pass home hero">
            <div className="bbp-hero-v2__media">
                {slides.map((slide, index) => (
                    <div
                        key={slide.src}
                        className={`hero-carousel-slide bbp-hero-v2__slide ${index === currentSlide ? "active" : ""}`}
                        style={{ backgroundImage: `url(${slide.src})` }}
                        aria-hidden={index !== currentSlide}
                    />
                ))}
            </div>

            <div className="hero-overlay bbp-hero-v2__overlay" />

            <div className="bbp-hero-v2__inner">
                <div className="bbp-hero-v2__copy">
                    <div className="bbp-hero-v2__eyebrow">
                        {activeSlide.eyebrow}
                        <span aria-hidden="true"></span>
                    </div>

                    <h1>{activeSlide.title}</h1>

                    <p className="bbp-hero-v2__subtitle">{activeSlide.subtitle}</p>

                    <p className="bbp-hero-v2__description">{activeSlide.description}</p>

                    <div className="bbp-hero-v2__actions">
                        <a className="bbp-hero-v2__btn bbp-hero-v2__btn--primary" href="/passes">
                            Get My Pass
                            <span aria-hidden="true">→</span>
                        </a>

                        <a className="bbp-hero-v2__btn bbp-hero-v2__btn--secondary" href="/discover">
                            Explore Activities
                            <span aria-hidden="true">〰</span>
                        </a>
                    </div>

                    <div className="bbp-hero-v2__social-rail" aria-label="Beach Bum Pass social links">
                        <SocialLinks variant="hero" className="bbp-hero-v2__social-links" />
                    </div>
                </div>
            </div>

            {slides.length > 1 ? (
                <div className="hero-dots bbp-hero-v2__dots">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            type="button"
                            aria-label={`Show slide ${index + 1}`}
                            className={`hero-dot ${index === currentSlide ? "active" : ""}`}
                            onClick={() => setCurrentSlide(index)}
                        />
                    ))}
                </div>
            ) : null}
        </section>
    );
}
